import athenaClient from "lib/axios/clients";
import buildRequestUrl from "lib/requests/requestUtils";
import _ from "lodash";

const getAsyncCompetitorCalculatedData = async (
  taskId,
  lastSeenStep = 0,
  timeoutId
) => {
  let localLastSeenStep = lastSeenStep;
  let localTimeoutid = timeoutId;

  if (localTimeoutid !== undefined) clearTimeout(localTimeoutid);

  try {
    const response = await athenaClient({
      method: "GET",
      url: buildRequestUrl(
        { last_seen_step: lastSeenStep },
        `status/${taskId}`
      ),
    });
    localLastSeenStep = response.data.task_info?.step || localLastSeenStep;
    if (
      response.data.task_status === "FAILURE" ||
      response.data.task_status === "SUCCESS"
    ) {
      clearTimeout(timeoutId);
      return response;
    }

    const sendRequestWithSomeTimeout = async () => {
      return new Promise((res) => {
        localTimeoutid = setTimeout(async () => {
          const tempResult = await getAsyncCompetitorCalculatedData(
            taskId,
            localLastSeenStep,
            localTimeoutid
          );
          res(tempResult);
        }, 350);
      });
    };

    const tempResult = await sendRequestWithSomeTimeout();
    return tempResult;
  } catch (error) {
    if (error.response?.status !== 504) {
      clearTimeout(localTimeoutid);
      throw error;
    }
  }
  return {};
};

export default async function getAsyncCompetitorsScenariosData(
  competitorsBaseData,
  cyclesListSlice,
  baseCompetitorScenarioData,
  username
) {
  const competitorsTasksResults = [];
  _.forEach(competitorsBaseData, (competitorData) => {
    competitorsTasksResults.push(
      getAsyncCompetitorCalculatedData(competitorData.taskData.data.task.id)
    );
  });
  const competitorCalulatedDataResult = await Promise.all(
    competitorsTasksResults
  );

  const cycleType = _.find(
    cyclesListSlice,
    (cycle) => cycle.id === baseCompetitorScenarioData?.cycleType
  );

  const competitorScenarioData = [];
  _.forEach(competitorCalulatedDataResult, (result, idx) => {
    if (result.data.task_status === "SUCCESS") {
      const competitorBaseData = competitorsBaseData[idx];
      const competitorCalculatedData = result.data.task_info.result;

      competitorScenarioData.push({
        name: competitorBaseData.name,
        comment: competitorBaseData.comment,
        scenarioId: baseCompetitorScenarioData.scenarioId,
        cycleLabel: baseCompetitorScenarioData.cycleLabel,
        cycleType: cycleType.id,
        defaultSliderData: competitorBaseData.sliderData,
        pathS3AffectedScenario:
          competitorCalculatedData.path_to_s3_affected_scenario,
        pathS3MarketShare: competitorCalculatedData.path_to_s3_market_share,
        ownerLabel: username,
        impacted_base_scenario: competitorCalculatedData.impacted_base_scenario,
        market_share_values: competitorCalculatedData.market_share_values,
        baseMarketShare: _.reduce(
          competitorCalculatedData.market_share_values,
          (prev, curr) => prev + curr.ms_modified,
          0
        ),
      });
    } else {
      throw new Error("FAILED");
    }
  });

  return competitorScenarioData;
}
